import React, { useState, useEffect } from 'react';
import { fetchWithLocale } from "components/utils/Api.jsx";
import { buildLocalePath } from "components/utils/Locale";
import OiCarousel from "components/shared/OiCarousel";

const ACTIVITY_CAROUSEL_BREAKPOINTS = [
  { minWidth: 320, slidesPerView: 1.2 },
  { minWidth: 425, slidesPerView: 2.2 },
  { minWidth: 640, slidesPerView: 3.2 },
  { minWidth: 768, slidesPerView: 4 },
  { minWidth: 1024, slidesPerView: 7 },
  { minWidth: 1440, slidesPerView: 7 },
  { minWidth: 1728, slidesPerView: 7 },
];

function CarouselActivities(props) {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [slidesSkeletons, setSlidesSkeletons] = useState(1);

  useEffect(() => {
    const updateSkeletonCount = () => {
      const width = window.innerWidth;
      if (width >= 1728) setSlidesSkeletons(9);
      else if (width >= 1440) setSlidesSkeletons(8);
      else if (width >= 1024) setSlidesSkeletons(5);
      else if (width >= 768) setSlidesSkeletons(4);
      else if (width >= 425) setSlidesSkeletons(2);
      else setSlidesSkeletons(3);
    };
    updateSkeletonCount();
    window.addEventListener("resize", updateSkeletonCount);
    return () => window.removeEventListener("resize", updateSkeletonCount);
  }, []);

  useEffect(() => {
    get_activities();
  }, []);

  function get_activities() {
    setLoading(true);
    return fetchWithLocale(`/get_activities.json`)
      .then(response => response.json())
      .then(json => {
        setActivities(json.activities);
        setLoading(false);
      })
      .catch(error => console.log(error));
  }

  return (
    <section className="caroussel">
      <section className="products-section">
        {loading ? (
          <section className="carousel-skeletons-loader carousel-home__skeleton-row">
            {Array.from({ length: slidesSkeletons }).map((_, idx) => (
              <div
                key={`activity-skeleton-${idx}`}
                className="activity-loader oi-skeleton oi-skeleton--wave"
                aria-hidden
              />
            ))}
          </section>
        ) : (
          <OiCarousel
            items={activities || []}
            gap={12}
            breakpoints={ACTIVITY_CAROUSEL_BREAKPOINTS}
            ariaLabel="Actividades"
            getItemKey={(activity) => `activities-label-${activity.id}`}
            renderItem={(activity) => (
              <a
                href={buildLocalePath(`categories/${activity.slug || activity.id}`)}
                className="product-activities-image oi-stack-center"
                target="_blank"
                rel="noopener noreferrer"
                title="View Details"
              >
                <span className="product-white-label oi-cover-center">{activity.name}</span>
              </a>
            )}
          />
        )}
      </section>
    </section>
  );
}

export default CarouselActivities;
